import React, { useContext, useEffect } from 'react';
import businessImage from '../../../../assets/business.png'
import jobsImage from '../../../../assets/jobsImage.png'
import servicesOffice from '../../../../assets/servicesOffice.png'
import illusLarge from '../../../../assets/Illustration.png'
import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Accordion from '../../../../components/accordian/accordian';
import PricingCard from '../../../../components/pricingCards/pricingCards';
import NavBar from '../../../../components/navbar/navbar';
import Footer from '../../../../components/footer/footer';
import { BaseURL } from '../../../../Files/BaseURL';
import AlertContext from '../../../../Context/Alert/AlertContext';



function Pricing() {
  const items = [
    {
      title: 'Why Choose Paycott?',
      content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    },
    {
      title: 'Section 2',
      content: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    },
    {
      title: 'Section 3',
      content: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    },
  ];

  const navigate = useNavigate()
  const [isChecked, setIsChecked] = useState(false);

  const [BusinessAccount, setBusinessAccount] = useState([])
  const {showAlert} = useContext(AlertContext);

  const fetchPricing = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/portfolio/businessprice`);
      const data = await response.json();
      setBusinessAccount(data);
    } catch (error) {
      console.error('Error fetching header links:', error);
    }
  };


  useEffect(() => {
    fetchPricing();
  }, []);

  const toggleSwitch = () => {
    setIsChecked(!isChecked);
  };
  return (
    <>
      <NavBar />
      <div className='bg-gray-100'>
        <div >
          <div className="xl:min-h-screen relative">
            <div className=' bg-gray-100 absolute -z-0 w-[100%] h-[90%] md:h-[70%]'>
            </div>
            <div className='flex flex-col items-center gap-2 md:gap-4 py-8 md:py-16 px-4 sm:px-8 lg:px-16 relative z-10'>
              <h1 className="text-2xl font-pop text-[#868686] lg:text-3xl font-normal my-4 text-center">Pricing</h1>
              <h1 className='text-4xl md:text-5xl font-pop font-semibold text-center'>There is a<span className='italic text-primarygreen'> plan for all</span></h1>
              <h1 className='text-4xl md:text-5xl font-pop font-semibold text-center'><span className='italic text-primarygreen'>kinds</span> of usage.</h1>
              <p className='text-center font-pop text-base max-w-[100%] md:max-w-[80%] xl:max-w-[60%] md:m-auto my-4'>Unlock the full potential of our services with flexible pricing options tailored to suit your needs. Whether you're a startup, a growing business, or an established enterprise, we have plans designed to empower your journey</p>
              <Link><img src={businessImage} className='my-6 py-3 max-w-60 max-h-14' alt="Description of the image" /></Link>

            </div>
            <img src={jobsImage} alt="" className='m-auto w-[90%]  xl:w-[80%] my-6 relative z-10' />
          </div>
        </div>



        <div className="flex flex-row gap-2 justify-center p-2 flex-wrap">
          {BusinessAccount.map((item, index) => (
            <div key={index}>
                <PricingCard
                  item={item}
                  checked={isChecked}
                />
            </div>
          ))}
        </div>
        <div className="bg-cover bg-center flex justify-start items-center h-screen/2 my-24 px-32" style={{ height: '50vh', backgroundImage: `url(${servicesOffice})` }}>
          <div className='flex flex-col'>
            <p className='text-4xl my-6 text-white'>Make business</p>
            <p className='text-4xl my-6 text-white'>Become business</p>
            <button onClick={() => { 
              if(localStorage.getItem("p@token")){
                navigate("/profileCreation") 
              }else{
                showAlert('You need to Login first or Create Account','danger');
                navigate('/signin')
              }
            }} className="my-6 bg-white border-2 border-light hover:bg-primarygreen text-primarygreen font-semibold hover:border-primarygreen hover:text-white py-2 px-8 text-xl font-pop rounded-full ease-in-out duration-300 max-w-80 max-h-11">
              Apply Now
            </button>
          </div>
        </div>
        <div className='my-16'>
          <h1 className='text-4xl md:text-5xl font-pop font-semibold text-center my-24'>Grow <span className='italic text-primarygreen'> your business</span> with <span className='italic text-primarygreen'> business account.</span> </h1>
        </div>
        <img src={illusLarge} alt="" className='m-auto w-[50%]  xl:w-[70%] my-24 relative z-10' />
        <div>
          <h1 className="text-2xl font-pop text-black lg:text-3xl font-semibold my-24 text-center">FAQs</h1>
        </div>
        <div className='max-w-[100%] md:max-w-[100%] xl:max-w-[100%] px-24'> <Accordion items={items} /></div>
      </div>
      <Footer />
    </>

  );
}

export default Pricing;
